import { ReactNode, useEffect } from "react"
import { useAppSelector } from "../../redux/store/hooks"
import { selectDashboardSelectedPatient } from "../../redux/ProfessionalDashboard"
import { useLocation, useNavigate } from "react-router-dom"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../../navigation/NavigationController"
import {
    mockPatientUsed,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../../redux/Onboarding"

interface RequirePatientSelectionProps {
    children: ReactNode
}

function RequirePatientSelection(props: RequirePatientSelectionProps) {
    const patient = useAppSelector(selectDashboardSelectedPatient)
    const navigate = useNavigate()
    const location = useLocation()

    const running = useAppSelector(selectOnboardingIsRunningState)
    const step = useAppSelector(selectOnboardingStep)

    useEffect(() => {
        if (patient === null && !mockPatientUsed(running, step)) {
            navigate(
                NavigationPaths[NAVIGATION_VIEW.PATIENT_SELECTION_VIEW].path
            )
        }
    }, [patient, location, running, step])

    return <>{props.children}</>
}

export default RequirePatientSelection
